import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getPOsForSubsite = createAsyncThunk('orders/getPOsForSubsite', async (filter) => {
  console.log("RANGE", filter);
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorders?range=[" + filter[1] + "," + filter[2] + "]&filter=" + filter[0], { headers: AuthHeader.authHeader()});
        return {data: response.data, count: response.headers["total-items"]};
    } catch (error) {
        console.log(error);
    }    
  });

  export const cancelPO = createAsyncThunk('orders/cancelPO', async (poId) => {
    try {
        const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/purchaseorder/cancel/" + poId, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const finalizePO = createAsyncThunk('orders/finalizePO', async (params) => {
        const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/purchaseorder/finalize",
          { poId: params.id, decoratorId: params.decoratorId, orderIds: params.orderIds },
          { headers: {
          ...AuthHeader.authHeader()
          }
       }
      );

      return {data: response.data, orderIds: params.orderIds};
  });

/*  export const finalizePO = createAsyncThunk('orders/finalizePO', async (poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/finalize/" + poId, { headers: {
      ...AuthHeader.authHeader(),
      'Content-Disposition': "attachment; filename=./po.xlsx",
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
    responseType: 'arraybuffer',
   }
  );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'po.xlsx');
    document.body.appendChild(link);
    link.click();
});*/

  export const allPOs = state => state.purchaseorders.pos;
  export const poCount = state => state.purchaseorders.poCount;
  export const currentFilter = state => state.purchaseorders.filter;
  export const oosError = state => state.purchaseorders.oosError;
  export const finalizeStatus = state => state.purchaseorders.finalizeStatus;
  export const latestPOId = state => state.purchaseorders.latestPOId;

  const initialState = {
    pos: [],
    poCount: 0,
    finalizeStatus: 'idle',
    cancelStatus: 'idle',
    latestPOId: 0,
    status: 'idle',
    filter: 'open',
    error: null,
    oosError: ""
  };

  const purchaseOrdersSlice = createSlice({
    name: 'purchaseorders',
    initialState,
    reducers: {
      setFilter(state, action) {
        state.filter = action;
      }
    },
    extraReducers(builder) {
        builder
          .addCase(getPOsForSubsite.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getPOsForSubsite.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.pos = action.payload.data;
            state.poCount = action.payload.count;
          })
          .addCase(getPOsForSubsite.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(cancelPO.pending, (state, action) => {
            state.cancelStatus = 'loading'
          })
          .addCase(cancelPO.fulfilled, (state, action) => {
            state.cancelStatus = 'succeeded';
            var idxToRemove = -1;
            for(var i=0; i<state.pos.length; i++) {
              if(state.pos[i].id === action.payload.poId) {
                idxToRemove = i;
                break;
              }
            }
            state.pos.splice(idxToRemove, 1);
            state.status = 'idle';
          })
          .addCase(cancelPO.rejected, (state, action) => {
            state.cancelStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(finalizePO.pending, (state, action) => {
            state.finalizeStatus = 'loading'
          })
          .addCase(finalizePO.fulfilled, (state, action) => {
            state.finalizeStatus = 'succeeded';
            state.status = 'idle';
            state.latestPOId = action.payload.data.poId;
            var idxToRemove = -1;
            for(var i=0; i<state.pos.length; i++) {
              if(state.pos[i].id === action.payload.poId) {
                idxToRemove = i;
                break;
              }
            }
            state.pos.splice(idxToRemove, 1);
            console.log(action.payload);
            state.oosError = action.payload.oosError;
          })
          .addCase(finalizePO.rejected, (state, action) => {
            state.finalizeStatus = 'failed';
            state.error = action.error.message;
          })
      }
  });
  
  export const { setFilter } = purchaseOrdersSlice.actions;
  export default purchaseOrdersSlice.reducer;




